import { createSlice } from '@reduxjs/toolkit'

const initialState = true

const licenseSlice = createSlice({
    name: 'licenseSlice',
    initialState,
    reducers: {
        licenseInvalid: (state) => {
            state = false
            return state
        },
    },
})

export const { actions: licenseActions } = licenseSlice
export const { reducer: licenseReducer } = licenseSlice
